const sports = require('~/data/sports.json')

export default function ({app, route}) {
    if (!_.includes(sports, _.get(route, 'params.sport'))) {
        //return app.context.error({ statusCode: 404, message: 'Page not found' })
    }
}